
class VariantSelectsCro extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.hideConditional();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateMetafields();
    //this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateDisabledOptions();
    this.hideConditional();
    

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateSkuinfo();
      this.updateMedia();
      this.updateURL();
      this.updateOptionText();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateCustomInputs();
    }
    this.outOfStock();
  }

  hideConditional(){
   
    var option1 = $(`variant-radios-cro[data-section='${this.dataset.section}'] fieldset.product-form__input[data-option="option1"]`).find("input:checked").val();
    var option1_remove = '';
    if (option1) {
      option1_remove = option1.replace(/'/g, '').replace(/"/g, '');
    }
    //console.log('option1_remove',option1_remove);
    
    var wxVariantSelect = $(`variant-radios-cro[data-section='${this.dataset.section}'] select.variants-wx-select`);

    var disallowFdrVariantElements = $(`variant-radios-cro[data-section='${this.dataset.section}'] select.variants-wx-select option[data-disallow_fdr="true"]`);
    var disallowFdrOption = '';
    if (disallowFdrVariantElements.length == 1) {
      var disallowFdrTitleFinal = disallowFdrVariantElements.attr('data-titlefinal');
      if (disallowFdrTitleFinal !== '') {
        var parts = disallowFdrTitleFinal.split('/');
        if (parts.length > 0) {
          disallowFdrOption = parts[0].trim() + ' /';
        }
      }
    }

    var checkedValues = $(`variant-radios-cro[data-section='${this.dataset.section}'] fieldset.product-form__input input:checked`).map(function() {
      return $(this).val();
    }).get();
    var allCheckedValues = checkedValues.join(" / ").replace(/'/g, '').replace(/"/g, '');
    //console.log(allCheckedValues);

    var disallowFdr  = wxVariantSelect.find("option[data-titlefinal='"+allCheckedValues+"']").data('disallow_fdr');
    ///console.log(disallowFdr)
    if(disallowFdr) {
      $(`#ProductInfo-${this.dataset.section} .see-deisgn-mock-area`).addClass('disabled');
      this.setUnavailable();
    } else {
      $(`#ProductInfo-${this.dataset.section} .see-deisgn-mock-area`).removeClass('disabled');
      // $('.product-form__submit.button').prop('disabled', false);
      // $('.product-form__submit.button').html('Add to cart');
      // if (disallowFdrOption !== '') {
      //   if (allCheckedValues.includes(disallowFdrOption)) {
      //     $('.see-deisgn-mock-area,.quick-add-modal-form-submit').addClass('disabled');
      //     this.setUnavailable();
      //   }
      // }
    }

    // $('.thumbnail-change-slider').addClass('activeSlider');

    var towOptions = $(`variant-radios-cro[data-section='${this.dataset.section}'] fieldset.product-form__input[data-option="option1"] input:checked,variant-radios-cro[data-section='${this.dataset.section}'] fieldset.product-form__input[data-option="option2"] input:checked`).map(function() {
      return $(this).val();
    }).get();
    var CheckedtowOptions = towOptions.join(" / ").replace(/'/g, '').replace(/"/g, '');
    // console.log(CheckedtowOptions);

    
    var threeOptions = $(`variant-radios-cro[data-section='${this.dataset.section}'] fieldset.product-form__input[data-option="option1"] input:checked,variant-radios-cro[data-section='${this.dataset.section}'] fieldset.product-form__input[data-option="option2"] input:checked,variant-radios-cro[data-section='${this.dataset.section}'] fieldset.product-form__input[data-option="option3"] input:checked`).map(function() {
      return $(this).val();
    }).get();
    var CheckedthreeOptions = threeOptions.join(" / ").replace(/'/g, '').replace(/"/g, '');
    // console.log(CheckedthreeOptions);


    // if($('.thumbnail-change-slider .thumbnail-list__item.spltCount3[data-final-alt="'+CheckedthreeOptions+'"]').length > 0){
    //   console.log('all values 3nd level: true');
    //   $('.thumbnail-change-slider .thumbnail-list__item:not(.donthideit)').removeClass('showimage').hide();
    //   $('.thumbnail-change-slider .thumbnail-list__item[data-final-alt="'+CheckedthreeOptions+'"]').addClass('showimage').show();

    // } else {

    //   if($('.thumbnail-change-slider .thumbnail-list__item[data-final-alt="'+CheckedtowOptions+'"]').length > 0){
      
    //     console.log('all values 2nd level: true');
    //     $('.thumbnail-change-slider .thumbnail-list__item:not(.donthideit)').removeClass('showimage').hide();
    //     $('.thumbnail-change-slider .thumbnail-list__item[data-final-alt="'+CheckedtowOptions+'"]').addClass('showimage').show();
      
    //   } else {

    //     if ($('.thumbnail-change-slider .thumbnail-list__item[data-alt="'+option1_remove+'"]').length > 0) {
    //       console.log('all values: false');
    //       $('.thumbnail-change-slider .thumbnail-list__item:not(.donthideit)').removeClass('showimage').hide();
    //       $('.thumbnail-change-slider .thumbnail-list__item[data-alt="'+option1_remove+'"]').addClass('showimage').show();
    //     }

    //   }
    // }



    
    if(option1 != ''){

      var occurances = 0;
      var option2Checked = $(`variant-radios-cro[data-section='${this.dataset.section}'] fieldset.product-form__input[data-option="option2"]`).find("input:checked");
      if(option2Checked.length){
        option2Checked.next('label').each(function(){ // loop option 2
          if($(`variant-radios-cro[data-section='${this.dataset.section}'] fieldset.product-form__input[data-option="option2"]`).hasClass('color')) {
            var option2 = $(this).prev('input').val();
          } else {
            var option2 = $(this).text().trim();
          }
          var option2Elem = $(this);
          $(`variant-radios-cro[data-section='${this.dataset.section}'] fieldset.product-form__input[data-option="option3"] label`).each(function(){ // loop option 3
            var option3 = $(this).prev('input').val();
            var variantTitle = `${option1} / ${option2} / ${option3}`;
            variantTitle = variantTitle.replaceAll("'" , "").replaceAll('"' , "");
            //console.log('variantTitle:',variantTitle);
            var length =  wxVariantSelect.find("option[data-titlefinal='"+variantTitle+"']").length;
            
            if(length > 0){
              occurances ++;
              $(this).attr("data-occurances", occurances);
              option2Elem.attr("data-occurances", occurances);
              $(this).prev('input').addClass('activeVariant-input');
              $(this).addClass('activeVariant').show();
            } else{
              $(this).prev('input').removeClass('activeVariant-input');
              $(this).removeClass('activeVariant').hide();
            }
            //
          }); 
          
        });  
      }
    }
  }
  outOfStock(){
    /*
    $('.product__info-wrapper .product-form__input input[type=radio]').remove('disabled', 'disabled');
    if(this.currentVariant && this.currentVariant.available == false){
      $('.product__info-wrapper .product-form__input input[type=radio]:checked').attr('disabled', 'disabled');
    }
    */
    $(`#ProductInfo-${this.dataset.section} .product-form__input input[type=radio]`).remove('disabled', 'disabled');
    if(this.currentVariant && this.currentVariant.available == false){
      $(`#ProductInfo-${this.dataset.section} .product-form__input input[type=radio]:checked`).attr('disabled', 'disabled');
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMetafields() {
    if(!this.parentElement.querySelector('#pro-metafields')) return;
    const metafieldData = JSON.parse(this.parentElement.querySelector('#pro-metafields').textContent);
    this.currentVariantMetafield = metafieldData.find((variant) => variant.id === this.currentVariant.id);
  }

  updateMedia() {    
    if (!this.currentVariant) return;
    if(!this.currentVariant.featured_media) return;
    const parentId = this.dataset.section;
    const gallerySlider = $('#Slider-Gallery-' + parentId);
    var gallerySliderVideo = $('.thumbnail-change-slider .thumbnail-list__item-video').length;
    if(gallerySliderVideo > 0 ){
     var mediaPositionCount = 1;  
    } else {
     var mediaPositionCount = 0; 
    }
    const mediaPosition = this.currentVariant.featured_image.position -mediaPositionCount;
    
    const datamediaPosition = mediaPosition + 1;
    if (typeof productMediaWrapper !== 'undefined') {      
      if (productMediaWrapper) {
        productMediaWrapper.change_gallery_position(gallerySlider, mediaPosition);
      }
    }
    
    window.setTimeout(() => { 
      if(document.getElementById('BIS_trigger')){
        if (this.currentVariant.available) {
          document.getElementById('BIS_trigger').style.display = 'none';
          $('#BIS_trigger').hide(); // hide the button
        } else {
          document.getElementById('BIS_trigger').style.display = 'block'; // show the button and set the default variant
        }
      }
    });    
  }

  updateURL() {
    /*
    if (!this.currentVariant) return;
    var historyPrams = '';

    if(this.currentVariant.options.length){
      if (!document.querySelector('#ProductJSON-' + this.dataset.section)) {
        return;
      }
      var productJson = JSON.parse(document.querySelector('#ProductJSON-' + this.dataset.section).textContent);
      var vOptions = this.options;
      var pOptionsNames = productJson.options;

      if(vOptions.length == 2){
        if(pOptionsNames[0] == 'Size'){
          historyPrams = `?variant=${vOptions[1]}&size=${vOptions[0]}`;
        }else{
          historyPrams = `?variant=${vOptions[0]}&size=${vOptions[1]}`;
        }
      }else if(vOptions.length == 1){
        if(pOptionsNames[0] == 'Size'){
          historyPrams = `?size=${vOptions[0]}`;
        }else{
          historyPrams = `?variant=${vOptions[0]}`;
        }
      }
    }
    window.history.replaceState({ }, '', `${window.location.pathname}${historyPrams}`);
    */
  }

  updateOptionText() {
    if (!this.querySelector('input:checked')) return;
    const inputs = this.querySelectorAll('input:checked');

    inputs.forEach((option,index) => {
      const wrap = option.closest('.product-form__input');
      const legend = wrap.querySelector('legend');
      const inputValue = option.value;
      if (!legend) return;

      const formLabelSpan = legend.querySelector('span');
      if (formLabelSpan) formLabelSpan.innerText = inputValue;
    })
  }

  updateDisabledOptions() {


    const option1Fieldset = this.querySelector('fieldset[data-option="option1"]');
    const option2Fieldset = this.querySelector('fieldset[data-option="option2"]');
    const option3Fieldset = this.querySelector('fieldset[data-option="option3"]');
    if(option1Fieldset && option2Fieldset) {
      var option1Inputs = option1Fieldset.querySelectorAll('input');
      for (var i = 0; i < option1Inputs.length; i++) {
        option1Inputs[i].disabled = true;
        option1Inputs[i].setAttribute('data-availability','false');
      }
    }
    if(option2Fieldset) {
      var option2Inputs = option2Fieldset.querySelectorAll('input');
      for (var i = 0; i < option2Inputs.length; i++) {
        option2Inputs[i].disabled = true;
        option2Inputs[i].setAttribute('data-availability','false');
      }
    }
    if(option3Fieldset) {
      var option3Inputs = option3Fieldset.querySelectorAll('input');
      for (var i = 0; i < option3Inputs.length; i++) {
        option3Inputs[i].disabled = true;
        option3Inputs[i].setAttribute('data-availability','false');
      }
    }
    this.options.forEach((option,index) => {
      var curr_option = option,
          curr_option_index = 'option'+(index+1),
          matching_variants = this.getVariantData().filter(function(element,index) {
            return element[curr_option_index] == curr_option;
          });
      let option1 = matching_variants.map(a => a.option1);
      let option2 = matching_variants.map(a => a.option2);
      let option3 = matching_variants.map(a => a.option3);
      switch(index) {
        case 0:
          if(!option2Fieldset) return;
            this.variantExistsCheck(option2Inputs,option2);
          if(!option3Fieldset) return;
            this.variantExistsCheck(option3Inputs,option3);
          break;
        case 1:
          if(!option1Fieldset) return;
            this.variantExistsCheck(option1Inputs,option1);
          if(!option3Fieldset) return;
            this.variantExistsCheck(option3Inputs,option3);
          break;
        case 2:
          if(!option1Fieldset) return;
            this.variantExistsCheck(option1Inputs,option1);
          if(!option2Fieldset) return;
            this.variantExistsCheck(option2Inputs,option2);
      }
    });
  }

  updateSkuinfo() {
    const parent = document.querySelector(`#ProductInfo-${this.dataset.section}`);
    if(!parent) return;
    parent.querySelector('.js-variant-sku').innerText = 'Sku: ' + this.currentVariant.sku + '';
    // if (document.querySelector('.js-variant-weight')) {
    //   document.querySelector('.js-variant-weight').innerText = 'Weight: ' + Math.round(this.currentVariant.weight / 453.6) + ' lb';
    // }
  }

updateVariantInput() {
    console.log('=== updateVariantInput called ===');
    console.log('Regular Price:', this.currentVariant.price);
    console.log('Compare-at Price:', this.currentVariant.compare_at_price);

    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      var Vtitle = this.currentVariant.title;
      input.value = this.currentVariant.id;

      var fdrWrap = $(`#ProductInfo-${this.dataset.section} #fdr-wrap:not(.disabled) a`).data('productv');
      if (fdrWrap == true) {
        var hrf = $(`#ProductInfo-${this.dataset.section} #fdr-wrap:not(.disabled) a`).data('href');
        $(`#ProductInfo-${this.dataset.section} #fdr-wrap:not(.disabled) a`).attr('href', hrf + '&variant=' + this.currentVariant.id);
      }

      input.setAttribute("data-price", this.currentVariant.price);

      // Update compare price if it exists (second position)
      if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
        console.log('Variant has compare price - updating both prices');
        console.log('Setting Regular Price to:', this.currentVariant.price);
        console.log('Setting Compare-at Price to:', this.currentVariant.compare_at_price);

        // Update regular price with current variant price
        var regularPriceFormatted = Shopify.formatMoney(this.currentVariant.price).replace(/((\,00))$/g, '');
        console.log('Formatted regular price:', regularPriceFormatted);
        $(`#ProductInfo-${this.dataset.section} dd.dd3 span.price-item.price-item--sale`).text(regularPriceFormatted);

        // Update compare price with compare_at_price
        var comparePriceFormatted = Shopify.formatMoney(this.currentVariant.compare_at_price).replace(/((\,00))$/g, '');
        console.log('Formatted compare price:', comparePriceFormatted);
        $(`#ProductInfo-${this.dataset.section} .price__sale dd.price__compare s.price-item.price-item--regular`).text(comparePriceFormatted);

        // Add sale class when compare price exists
        $(`#ProductInfo-${this.dataset.section} .price.price--large`).addClass('price--on-sale');

        // Debug: Check if elements exist
        console.log('Regular price elements found:', $(`#ProductInfo-${this.dataset.section} .price--large .price-item--regular,#ProductInfo-${this.dataset.section} .product_price .append-price-item`).length);
        console.log('Compare price elements found:', $(`#ProductInfo-${this.dataset.section} .price--large .price-item--sale,#ProductInfo-${this.dataset.section} .product_price .compare-price-item`).length);
      } else {
        console.log('Variant has NO compare price - updating regular price only');
        console.log('Setting Regular Price to:', this.currentVariant.price);

        // When no compare price, update regular price only
        var regularPriceFormatted = Shopify.formatMoney(this.currentVariant.price).replace(/((\,00))$/g, '');
        console.log('Formatted regular price (no compare):', regularPriceFormatted);

        // Try updating in both possible locations
        $(`#ProductInfo-${this.dataset.section} dd.dd3 span.price-item.price-item--sale`).text(regularPriceFormatted);
        $(`#ProductInfo-${this.dataset.section} .price.price--large .price__regular span.price-item.price-item--regular`).text(regularPriceFormatted);

        console.log('dd.dd3 elements found:', $(`#ProductInfo-${this.dataset.section} dd.dd3 span.price-item.price-item--sale`).length);
        console.log('price__regular elements found:', $(`#ProductInfo-${this.dataset.section} .price.price--large .price__regular span.price-item.price-item--regular`).length);

        // Remove sale class when no compare price
        $(`#ProductInfo-${this.dataset.section} .price.price--large`).removeClass('price--on-sale');

        // Debug: Check if elements exist
        console.log('Regular price elements found:', $(`#ProductInfo-${this.dataset.section} .price--large .price-item--regular,#ProductInfo-${this.dataset.section} .product_price .append-price-item`).length);
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
      /*
      if(Vtitle.includes("Frame Only")){
        document.querySelector('.product__info-wrapper').classList.add('hide-art');
      } else {
        document.querySelector('.product__info-wrapper').classList.remove('hide-art');
      }
      */

      if (!this.currentVariantMetafield) return;
      const currentVariantMetafieldKeys = Object.keys(this.currentVariantMetafield.metafields);
      currentVariantMetafieldKeys.forEach((level) => {
        if (productForm.querySelector(`input[name="properties[_price-${level}]"]`)) {
          productForm.querySelector(`input[name="properties[_price-${level}]"]`).value = this.currentVariantMetafield.metafields[level];
        }
      });
    });
  }

  updateCustomInputs(){
    if (!this.currentVariant) return;
    const cvId = this.currentVariant.id;

    // $('.product-form__addon--capsule').attr('data-target', `#product-modal-${cvId}-addons`);
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    productForm.product_price_update(this.dataset.section);
    productForm.product_installment_update(this.dataset.section);
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const priceid = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(priceid);
        const source = html.getElementById(priceid);

        const addonId = `product-form__addon-${this.dataset.section}`;
        const addondestination = document.getElementById(addonId);
        const addonsource = html.getElementById(addonId);

        const customSelector = `gf-product-custom-selector-${this.dataset.section}`;
        const customSelectordestination = document.getElementById(customSelector);
        const customSelectorsource = html.getElementById(customSelector);
        const uploaderWrap = html.querySelector('.product-custom-upload__upload-wrapper');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (addondestination && addonsource){ addondestination.innerHTML = addonsource.innerHTML;}
        if (uploaderWrap){window.Cloudlift.upload.App.setup();}
        if (customSelectordestination && customSelectorsource) customSelectordestination.innerHTML = customSelectorsource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const klayvioTrigger = productForm.querySelector('.klaviyo-bis-trigger');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text){
        addButton.textContent = text;
        //addButton.style.display = 'none';
        //klayvioTrigger.classList.remove('hide');
      }else{
        //addButton.style.display = 'block';
        //klayvioTrigger.classList.add('hide');
      }
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
      //addButton.style.display = 'block';
      //klayvioTrigger.classList.remove('hide');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  variantExistsCheck(inputs,options) {
    for (var i = 0; i < inputs.length; i++) {
      if(options.includes(inputs[i].value)) {
        inputs[i].disabled = false;
        inputs[i].setAttribute('data-availability','true');
      } 
    }
  }
}

customElements.define('variant-selects-cro', VariantSelectsCro);

class VariantRadiosCro extends VariantSelectsCro {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios-cro', VariantRadiosCro);
